import type { ComponentType } from 'react';
import { TaxSmall, ShippingSmall, SiteSearchSmall } from '@wix/wix-ui-icons-common';
import type { ExistingSiteStoreReadyBoxId } from './existingSiteStoreReadyUiStore';

export interface ExistingSiteStoreReadyTask {
  id: ExistingSiteStoreReadyBoxId;
  icon?: ComponentType;
  title: string;
  description: string;
}

export interface ExistingSiteStoreReadyTaskDef {
  id: ExistingSiteStoreReadyBoxId;
  icon?: ComponentType;
}

/** Task order and ids; copy comes from `locales/en.existing-site-store-ready.json` via `useTranslation`. */
export const EXISTING_SITE_STORE_READY_TASK_DEFS: readonly ExistingSiteStoreReadyTaskDef[] = [
  { id: 'page-ready' },
  { id: 'margin', icon: TaxSmall },
  { id: 'delivery', icon: ShippingSmall },
  { id: 'add-more-products', icon: SiteSearchSmall },
];

export function getExistingSiteStoreReadyTaskTitleKey(id: ExistingSiteStoreReadyBoxId): string {
  return `existing-site-store-ready.tasks.${id}.title`;
}

export function getExistingSiteStoreReadyTaskDescriptionKey(id: ExistingSiteStoreReadyBoxId): string {
  return `existing-site-store-ready.tasks.${id}.description`;
}
